import React from 'react';
import { Stack, TableRow } from '@mui/material';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import CurrencyValue from '../../../components/material-ui/CurrencyValue';
import { useAppSelector } from '../../../store';
import { useTranslation } from 'react-i18next';
import { stickyCellBottom, stickyCellRight } from '../../../components/bonus/ui/styles';
import zIndex from '@mui/material/styles/zIndex';

export default function ReportBonusTotal({ CountValue }) {
  const { t } = useTranslation();
  const bonusesTotal = useAppSelector((state) => state.reports.bonuses.total);
  const currency = useAppSelector((state) => state.reports.bonuses.payload?.currency);

  const miniJack = bonusesTotal.jackpot?.mini || [];
  const majorJack = bonusesTotal.jackpot?.major || [];
  const grandJack = bonusesTotal.jackpot?.grand || [];

  const welcome = bonusesTotal.welcome || [];
  const cashback = bonusesTotal.cashback || [];
  const freespin = bonusesTotal.freespin || [];
  const promocode = bonusesTotal.promocode || [];
  const startBot = bonusesTotal.startBot || [];
  const botPhone = bonusesTotal.botPhone || [];

  const bonusTotal =
    miniJack[1] +
    majorJack[1] +
    grandJack[1] +
    welcome[1] +
    cashback[1] +
    freespin[1] +
    promocode[1] +
    startBot[1] +
    botPhone[1];

  return (
    <TableRow sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
      <MyTableCell isLess sx={{ pl: 2, ...stickyCellBottom }}>
        <TypographyText fontWeight={800}>{t('Total')}</TypographyText>
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom} type="numeric">
        <CountValue value={miniJack[1]} count={miniJack[0]} />
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom} type="numeric">
        <CountValue value={majorJack[1]} count={majorJack[0]} />
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom} type="numeric">
        <CountValue value={grandJack[1]} count={grandJack[0]} />
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={welcome[1]} count={welcome[0]} />
          <CountValue value={welcome[3]} count={welcome[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={freespin[1]} count={freespin[0]} />
          <CountValue value={freespin[3]} count={freespin[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={cashback[1]} count={cashback[0]} />
          <CountValue value={cashback[3]} count={cashback[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={promocode[1]} count={promocode[0]} />
          <CountValue value={promocode[3]} count={promocode[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell isLess sx={stickyCellBottom}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={startBot[1]} count={startBot[0]} />
          <CountValue value={startBot[3]} count={startBot[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell isLess sx={{ ...stickyCellBottom }}>
        <Stack gap={0.5} alignItems={'end'}>
          <CountValue value={botPhone[1]} count={botPhone[0]} />
          <CountValue value={botPhone[3]} count={botPhone[2]} />
        </Stack>
      </MyTableCell>
      <MyTableCell
        isLess
        sx={{ pl: 2, ...stickyCellBottom, ...stickyCellRight, zIndex: 3 }}
        type="numeric">
        <CurrencyValue value={bonusTotal} currency={currency} fontSize={12} fontWeight={900} />
      </MyTableCell>
    </TableRow>
  );
}
